module.exports = __webpack_public_path__ + "media/images/plans/plan-konintodoke-photo-7ec947289bf4650a4dd3b117774b1599.jpg";